import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-qb',
  templateUrl: './qb.component.html',
  styleUrls: ['./qb.component.css']
})
export class QbComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/qb/qb.component.ts